import "styles/profile/veriff.less";

import { useEffect, useState, useContext, useRef } from "react";

import { createVeriffFrame, MESSAGES } from "@veriff/incontext-sdk";
import { AppContext } from "App";
import errorIcon from "assets/images/error_icon.png";
import LottieAnimation from "components/basic/Spinner/Lottie";
import { useUser } from "hooks/common/useUser";
import { useCreateSessionMutation } from "services/veriff";

import { logError } from "../../../../../../utils/sentry";

interface IVeriffStartPageProps {
    advanceStep: () => void;
}

function VeriffComponent({ advanceStep }: IVeriffStartPageProps) {
    const [sessionUrl, setSessionUrl] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(true);
    const { user } = useUser();
    const { isMobile } = useContext(AppContext);
    const [createSession] = useCreateSessionMutation();
    const veriffRootRef = useRef<HTMLDivElement>(null);

    // Create Veriff session on mount
    useEffect(() => {
        createSession({})
            .unwrap()
            .then(response => {
                if (response.sessionUrl) {
                    setSessionUrl(response.sessionUrl);
                }
            })
            .catch(error => {
                logError("Error creating Veriff session:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [user, createSession]);

    useEffect(() => {
        if (sessionUrl && veriffRootRef.current) {
            const veriffFrame = createVeriffFrame({
                url: sessionUrl,
                embedded: true,
                embeddedOptions: {
                    rootElementID: "veriff-root",
                },
                onEvent: (msg: MESSAGES) => {
                    if (msg === MESSAGES.FINISHED) {
                        advanceStep();
                    }
                },
                onReload: () => {
                    window.location.reload();
                },
            });

            return () => {
                veriffFrame?.close();
            };
        }
    }, [sessionUrl, advanceStep]);

    return (
        <div className="profile__content">
            <LottieAnimation isLoading={loading} />
            {!loading && sessionUrl ? (
                <div
                    id="veriff-root"
                    ref={veriffRootRef}
                    style={
                        isMobile
                            ? { width: "335px", height: "600px", border: "none" }
                            : { width: "1200px", height: "800px", border: "none" }
                    }
                />
            ) : (
                !loading && (
                    <div style={{ marginTop: "150px" }}>
                        <img className="veriff__error__icon" alt="error icon" src={errorIcon} />
                        <div
                            className="veriff__content-title"
                            style={{ fontSize: "19px", marginBottom: "12px" }}
                        >
                            Something went wrong
                        </div>
                        <div
                            className="veriff__content-text"
                            style={{ padding: "0 30px 30px 30px" }}
                        >
                            Something went wrong with Veriff. Please try again or contact support@taxzap.co.uk.
                        </div>
                    </div>
                )
            )}
        </div>
    );
}

export default VeriffComponent;
